import { RootState } from '..';

export const selectIsConfigInitialized = (state: RootState) =>
  state.config.isInitialized;

export const selectSupportedCountries = (state: RootState) =>
  state.config.supportedCountries;

export const selectIsLoadingCountries = (state: RootState) =>
  state.config.isLoadingCountries;

export const selectCountriesError = (state: RootState) =>
  state.config.countriesError;

export const selectIsInialized = (state: RootState) =>
  state.config.isInitialized;
